<template>
  <div class="flex gap-2 py-2 pl-4 o:m-0 children:skeleton">
    <div class="h-4 w-5 md:w-10" />
    <div class="h-4 w-16" />
    <div class="h-4 w-16" />
    <div class="h-4 w-12 <md:hidden" />
  </div>
</template>
